































import { Component, Watch, Mixins } from 'vue-property-decorator';
import { Debounce, FeatureEnabledV2 } from '@gig/magic-common';
import { MetaMixin } from '../../../mixins/meta.mixin';
import { RouteName } from '../../routes.constants';

import {
    SEARCH_DEBOUNCE_MS,
    SEARCH_QUERY_PARAM,
} from './faq.constants';
import { Feature } from '../../../util/features';

@Component
export default class FaqPage extends Mixins(MetaMixin) {
    query: string | Array<string | null> = '';
    
    @FeatureEnabledV2({
        slug: Feature.TOP_NAVIGATION,
    })
    isTopNavigationEnabled = false;

    created() {
        this.setPage('faqs');
        this.query = this.$route.query[SEARCH_QUERY_PARAM] || '';
    }

    @Watch('query')
    @Debounce(SEARCH_DEBOUNCE_MS)
    search() {
        if (!this.query) {
            this.$router.push({ name : RouteName.FAQ_CATEGORIES });
            return;
        }

        const newRoute = {
            name: RouteName.FAQ_SEARCH,
            query: this.query ? { [SEARCH_QUERY_PARAM]: this.query } : undefined,
        };

        if (this.$route.name === RouteName.FAQ_SEARCH) {
            this.$router.replace(newRoute);
        } else {
            this.$router.push(newRoute);
        }
    }
}
